module.exports = __webpack_public_path__ + "img/upload-thatbai.7fcc3491.svg";